var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { APIPermissions, BaseUserDto } from "./user.dtos";
import { IsDate, IsEnum, IsOptional, IsString, IsNumber, ValidateNested } from "class-validator";
export class APIKeyDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], APIKeyDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], APIKeyDto.prototype, "name", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], APIKeyDto.prototype, "apiKey", void 0);
__decorate([
    IsEnum(APIPermissions, { each: true }),
    __metadata("design:type", Array)
], APIKeyDto.prototype, "permissions", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], APIKeyDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => BaseUserDto),
    IsOptional(),
    __metadata("design:type", Object)
], APIKeyDto.prototype, "createdBy", void 0);
export class APIKeyCreationDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], APIKeyCreationDto.prototype, "apiKey", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], APIKeyCreationDto.prototype, "apiSecret", void 0);
export class APIKeysResult {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], APIKeysResult.prototype, "total", void 0);
__decorate([
    Type(() => APIKeyDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], APIKeysResult.prototype, "results", void 0);
